module.exports = __webpack_public_path__ + "img/logos_enes07.8bb84339.png";